// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"d90182597323d37e6804","883":"ee10a0e7341cd86db839"}[chunkId] + ".js";
};